import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { TranslocoService, TranslocoPipe } from '@jsverse/transloco';
import { SystemSettingsService } from '../system-settings.service';
import { WorkingDaysResponse } from '../system-settings-models';
import { RouterLink } from '@angular/router';
import { EditIconComponent } from '@kuiper/icons';
import { TenantService } from '../../../../common/services/tenant/tenant.service';
import { TenantPathPipe } from '../../../../common/pipes/tenant-path/tenant-path.pipe';
import { ADMIN_ROUTES } from '../../../../common/constants/admin.routing.constants';

@Component({
  selector: 'app-view-setting-working-days',
  imports: [TranslocoPipe, RouterLink, EditIconComponent, TenantPathPipe],
  templateUrl: './view-setting-working-days.component.html',
  styleUrl: './view-setting-working-days.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ViewSettingWorkingDaysComponent {
  readonly ADMIN_ROUTES = ADMIN_ROUTES;

  translocoService = inject(TranslocoService);
  systemSettingsService = inject(SystemSettingsService);
  tenantService = inject(TenantService);

  currentLang = this.translocoService.getActiveLang();
  workingDays = input<WorkingDaysResponse>();

  // Current timezone offset from UTC in hours
  currentTimezoneOffsetHours = new Date().getTimezoneOffset() / -60;

  convertTo12Hour(time: string | undefined): string {
    if (!time) return '';

    const [hourStr, minuteStr] = time.split(':');
    let hour = parseInt(hourStr, 10);

    // Add 3 hours to the time
    hour = (hour + this.currentTimezoneOffsetHours) % 24;

    const minute = minuteStr || '00';

    let amPm = hour >= 12 ? 'PM' : 'AM';
    if (this.currentLang === 'ar') {
      amPm = hour >= 12 ? 'م' : 'ص';
    }
    hour = hour % 12;
    hour = hour ? hour : 12; // Convert 0 to 12

    return `${hour}:${minute} ${amPm}`;
  }

  isLastWorkingDay(currentDay: any): boolean {
    const days = this.workingDays()?.days;
    if (!days) return false;

    const currentIndex = days.findIndex(
      day => day.name.value === currentDay.name.value
    );

    // Find the last day with is_working set to true
    for (let i = currentIndex + 1; i < days.length; i++) {
      if (days[i].is_working) {
        return false;
      }
    }

    return true;
  }
}
